import { Box, Paper, Stack } from "@mui/material";
import ListLink from "../generic/ListLink";
import { REPORT_VALUES, reportHref } from "../../constants";

const PROFESSIONAL_STANDARDS_HREF = reportHref(
  REPORT_VALUES.professionalStandardsMonthly
);

const ALL_STANDARD_LINKS = [
  {
    label: "CAEP Standards Alignment",
    href: reportHref(REPORT_VALUES.caepQuadrimestral),
  },
  {
    label: "AAQEP Standards Alignment",
    href: reportHref(REPORT_VALUES.aaqepQuadrimestral),
  },
  {
    label: "NELP & PSEL Leadership Standards",
    href: reportHref(REPORT_VALUES.nelpPselQuadrimestral),
  },
  {
    label: "Professional Standards Summary Report",
    href: PROFESSIONAL_STANDARDS_HREF,
  },
];

const PROFESSIONAL_STANDARDS_ONLY_LINKS = [
  {
    label: "Professional Standards Summary Report",
    href: PROFESSIONAL_STANDARDS_HREF,
  },
];

const ProfessionalStandardsTile = ({
  showOnlyProfessionalStandardsReport = true,
}) => {
  const links = showOnlyProfessionalStandardsReport
    ? PROFESSIONAL_STANDARDS_ONLY_LINKS
    : ALL_STANDARD_LINKS;

  return (
    <Paper
      className="edsimsV2-cohort-dashboard-card edsimsV2-standards-tile-card"
      elevation={0}
    >
      <Box className="edsimsV2-cohort-dashboard-header">
        <Box component="h2" className="edsimsV2-tile-title">
          Professional standards
        </Box>
        <p className="edsimsV2-tile-body">
          Simulations are aligned to national educator preparation standards.
          Explore alignment documentation and compliance reports below.
        </p>
      </Box>
      <Stack component="ul" className="edsimsV2-tile-link-list" spacing={0}>
        {links.map((item, index) => (
          <ListLink
            key={item.label}
            label={item.label}
            href={item.href}
            variant="plain"
            divider={index < links.length - 1}
          />
        ))}
      </Stack>
    </Paper>
  );
};

export default ProfessionalStandardsTile;
